import _ from 'lodash'
import React from 'react'
import styled, { css } from 'styled-components'

import { Flex, FlexProps } from '../Flex'
import { brkmax, themeColor, themeSpace, FontSizes, themeFontSize } from '../theme'

export interface LabeledValueProps extends FlexProps {
  label: React.ReactNode
  value: React.ReactNode
  disableMarginBottom?: boolean
  size?: FontSizes
}

const LabeledValueContainer = styled(Flex)<{ disableMarginBottom?: boolean }>`
  flex-direction: column;
  margin-bottom: ${({ disableMarginBottom }) => (disableMarginBottom ? 0 : themeSpace(3))};
`

const Label = styled.span<{ size: FontSizes }>`
  display: flex;
  font-size: ${({ size }) => themeFontSize(size)};
  font-weight: bold;
  color: ${themeColor('primary')};
  margin-bottom: ${themeSpace(2)};

  ${brkmax(
    1,
    css`
      margin-bottom: ${themeSpace(1)};
    `
  )}
`

const Value = styled.span`
  display: flex;
`

export const LabeledValue = ({ label, value, size, ...rest }: LabeledValueProps) => {
  return (
    <LabeledValueContainer {...rest}>
      <Label size={size || 'medium'}>{label}</Label>
      {_.isString(value) ? <Value>{value}</Value> : value}
    </LabeledValueContainer>
  )
}
